import React, { JSX, lazy, useEffect } from 'react';
import './App.css';
import { ApolloProvider } from "@apollo/client/react";
import { CssBaseline, ThemeProvider } from '@mui/material';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { graphQLClient } from './config/apollo';
import theme from './config/theme';
import { withSuspense } from './hoc/with-suspens';
import { Layout } from './components/layouts/Layout';
import NotFoundPage from './pages/NotFoundPage';
import i18n from './config/i18next';
import { DEVIS_BUFFET, MIDI_COMMANDES } from './constants/routing';

export type RoutePageProps = {
  locale: string;
  // commonRichtextStyle?: CommonRichtextStyle;
  slug?: string;
};

/**
 * Scroll top on each route change
 */
const ScrollToTop = ({ children }: React.PropsWithChildren) => {
  const location = useLocation();
  useEffect(() => {
    globalThis.scrollTo(0, 0);
  }, [location]);
  return <>{children}</>;
};

const withLazy = (pagePath: string) =>
  withSuspense(
    lazy(
      () =>
        import(`./pages/${pagePath}`) as Promise<{
          default: ({ locale, slug }: RoutePageProps) => JSX.Element;
        }>
    ),
    { locale: 'fr' }
  );

const App = () => {
  console.log('i18n.language: %s', i18n.language);
  return (
    <HelmetProvider>
      <ApolloProvider client={graphQLClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <BrowserRouter>
            <ScrollToTop>
              <Routes>
                <Route element={<Layout locale="fr" />}>
                  <Route index element={withLazy('Homepage')} />
                  <Route path={MIDI_COMMANDES} element={withLazy('MidiCommandesPage')} />
                  <Route path={`${MIDI_COMMANDES}/:commandeId`} element={withLazy('MidiCommandeConfirmPage')} />
                  <Route path={DEVIS_BUFFET} element={withLazy('DevisBuffetPage')} />
                  <Route path={':slug/'} element={withLazy('PageBasique')} />
                  <Route path="*" element={<NotFoundPage />} />
                </Route>
              </Routes>
            </ScrollToTop>
          </BrowserRouter>
        </ThemeProvider>
      </ApolloProvider>
    </HelmetProvider>
  );
}

export default App;
